export default class AssociationInfo {
    constructor(serverData) {
        var _a, _b, _c;
        Object.defineProperty(this, "associationId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "associationName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "associationSlug", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "properties", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        if (!(serverData === null || serverData === void 0 ? void 0 : serverData.success) || !(serverData === null || serverData === void 0 ? void 0 : serverData.data)) {
            return;
        }
        const { data } = serverData;
        this.associationId = (_a = data.associationId) !== null && _a !== void 0 ? _a : '';
        this.associationName = (_b = data.associationName) !== null && _b !== void 0 ? _b : '';
        this.associationSlug = (_c = data.associationSlug) !== null && _c !== void 0 ? _c : '';
        if (data.properties) {
            this.properties = data.properties.map((p) => {
                var _a, _b, _c;
                return ({
                    code: (_a = p.code) !== null && _a !== void 0 ? _a : '',
                    id: parseInt(String((_b = p.id) !== null && _b !== void 0 ? _b : ''), 10) || 0,
                    name: (_c = p.name) !== null && _c !== void 0 ? _c : '',
                });
            });
        }
    }
}
